// extracted by mini-css-extract-plugin
export var button = "navigation-button-module--button--8Do43";
export var buttonWrapper = "navigation-button-module--button-wrapper--gkLjQ";
export var orange = "navigation-button-module--orange--6i7hv";